function setupJoinForm() {
  const form = document.querySelector("[data-join-form]")
  if (!form) return

  const registrationType = form.querySelector("[data-registration-type]")
  const feedback = document.querySelector("[data-join-feedback]")
  const submitButton = form.querySelector("[data-submit-button]")
  const submitLabel = form.querySelector("[data-submit-label]")
  const labelTargets = form.querySelectorAll("[data-label-individual][data-label-institutional]")
  const placeholderTargets = form.querySelectorAll("[data-placeholder-individual][data-placeholder-institutional]")
  const groupRequiredFields = form.querySelectorAll("[data-required-for]")
  const otherNetworksTriggers = form.querySelectorAll("[data-other-networks-trigger]")
  const otherNetworksDetails = form.querySelector("[data-other-networks-details]")
  const otherNetworksRequiredFields = form.querySelectorAll("[data-required-when-other-networks]")
  const checkboxGroups = [...new Set(Array.from(form.querySelectorAll("[data-checkbox-group]")).map((input) => input.dataset.checkboxGroup))]
  const defaultSubmitLabel = submitLabel?.textContent || "Enviar solicitud"

  const setFeedback = (message, tone = "neutral") => {
    if (!feedback) return

    const tones = {
      neutral: "border-olive-200 bg-olive-50 text-olive-900",
      success: "border-emerald-200 bg-emerald-50 text-emerald-900",
      error: "border-red-200 bg-red-50 text-red-900"
    }

    feedback.className = `mt-6 rounded-2xl border px-4 py-3 text-sm/7 ${tones[tone] || tones.neutral}`
    feedback.textContent = message
    feedback.classList.remove("hidden")
  }

  const updateCheckboxGroupRequired = (groupName) => {
    const inputs = Array.from(form.querySelectorAll(`[data-checkbox-group="${groupName}"]`))
    if (!inputs.length) return

    const hasChecked = inputs.some((input) => input.checked)
    inputs.forEach((input, index) => {
      input.required = !hasChecked && index === 0
    })
  }

  const syncRegistrationGroups = () => {
    const selected = registrationType?.value || ""

    labelTargets.forEach((target) => {
      const nextLabel = selected === "institutional" ? target.dataset.labelInstitutional : target.dataset.labelIndividual
      target.textContent = nextLabel
    })

    placeholderTargets.forEach((target) => {
      target.placeholder = selected === "institutional" ? target.dataset.placeholderInstitutional : target.dataset.placeholderIndividual
    })

    form.querySelectorAll("[data-conditional-group]").forEach((group) => {
      const active = group.dataset.conditionalGroup === selected
      group.classList.toggle("hidden", !active)

      group.querySelectorAll("input, select, textarea").forEach((field) => {
        if (!field.name) return
        field.disabled = !active
      })
    })

    groupRequiredFields.forEach((field) => {
      field.required = field.dataset.requiredFor === selected
    })

    syncOtherNetworksFields()
  }

  const syncOtherNetworksFields = () => {
    const selectedRegistrationType = registrationType?.value || ""
    const selectedValue = form.querySelector('[name="other_networks_participation"]:checked')?.value || ""
    const active = selectedRegistrationType === "institutional" && selectedValue === "yes"

    if (otherNetworksDetails) {
      otherNetworksDetails.classList.toggle("hidden", !active)
    }

    otherNetworksRequiredFields.forEach((field) => {
      field.disabled = selectedRegistrationType !== "institutional" || !active
      field.required = active && field.dataset.requiredWhenOtherNetworks === "yes"
    })
  }

  registrationType?.addEventListener("change", syncRegistrationGroups)
  otherNetworksTriggers.forEach((input) => input.addEventListener("change", syncOtherNetworksFields))

  checkboxGroups.forEach((groupName) => {
    updateCheckboxGroupRequired(groupName)
    form.querySelectorAll(`[data-checkbox-group="${groupName}"]`).forEach((input) => {
      input.addEventListener("change", () => updateCheckboxGroupRequired(groupName))
    })
  })

  form.querySelector('input[name="submitted_at"]')?.setAttribute("value", new Date().toISOString())
  syncRegistrationGroups()
  syncOtherNetworksFields()

  form.addEventListener("submit", async (event) => {
    event.preventDefault()

    if (!form.reportValidity()) return

    submitButton?.setAttribute("disabled", "disabled")
    if (submitLabel) submitLabel.textContent = "Enviando..."
    setFeedback("Validando y enviando tu solicitud...", "neutral")

    const formData = new FormData(form)
    const payload = new URLSearchParams()
    formData.forEach((value, key) => {
      payload.append(key, value.toString())
    })

    try {
      const response = await fetch(form.action, {
        method: "POST",
        body: payload.toString(),
        headers: {
          Accept: "application/json",
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          "X-Requested-With": "join-form"
        }
      })

      const data = await response.json().catch(() => ({}))

      if (!response.ok) {
        throw new Error(data.error || "No se ha podido enviar la solicitud. Revisa los campos e inténtalo de nuevo.")
      }

      setFeedback("Solicitud enviada. La revisaremos y contactaremos contigo en cuanto podamos.", "success")
      form.reset()
      form.querySelector('input[name="submitted_at"]')?.setAttribute("value", new Date().toISOString())
      syncRegistrationGroups()
      checkboxGroups.forEach((groupName) => updateCheckboxGroupRequired(groupName))

      if (window.turnstile) {
        const widget = form.querySelector(".cf-turnstile")
        if (widget) window.turnstile.reset(widget)
      }
    } catch (error) {
      setFeedback(error.message || "Ha ocurrido un error al enviar la solicitud.", "error")
    } finally {
      submitButton?.removeAttribute("disabled")
      if (submitLabel) submitLabel.textContent = defaultSubmitLabel
    }
  })
}

document.addEventListener("DOMContentLoaded", setupJoinForm)
